const FORM_TYPES = {
  HUBSPOT: 'HUBSPOT',
  FLOW: 'FLOW'
};
export default FORM_TYPES;